export const getSearchParamsObject = () => {
    const queryParams = new URLSearchParams(window.location.search);
    const queryObject = {};
    queryParams.forEach((value, key) => {
        queryObject[key] = value;
    });

    return queryObject;
};

export const setSearchParams = (searchParams = []) => {
    const queryParams = new URLSearchParams(window.location.search);
    searchParams.forEach(({ key, value }) => {
        queryParams.set(key, value);
    });

    window.history.pushState({}, "", `?${queryParams.toString()}`);
};

export const deleteSearchParams = (searchParams = []) => {
    const queryParams = new URLSearchParams(window.location.search);
    searchParams.forEach(({ key }) => {
        queryParams.delete(key);
    });

    window.history.pushState({}, "", `?${queryParams.toString()}`);
}

export const getString = (value) => {
    return value && value !== 'undefined' ? value : null;
}

export const getBoolean = (value) => {
    return value && value !== 'undefined' ? value === 'true' : null;
}

export const getNumber = (value) => {
    return value && value !== 'undefined' ? Number(value) : null;
}
